/*
 * File: cell-promo-code-usage.ts
 * Created: 2026-01-19 20:10:00
 * Author: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellPromoCodeUsage extends BaseTableBodyCell {
    get usedCount() {
        return this.row?.usedCount ?? 0;
    }

    get maxUses() {
        return this.row?.maxUses ?? null;
    }

    get maxUsesText() {
        return this.maxUses == null ? this.$_("w_Unlimited") : this.maxUses;
    }

    get hasLimit() {
        return this.maxUses != null;
    }

    get progressPercent() {
        if (!this.hasLimit) return 0;
        const max = Number(this.maxUses) || 0;
        if (max <= 0) return 0;
        const used = Math.max(0, Number(this.usedCount) || 0);
        return Math.min(100, Math.round((used / max) * 100));
    }

    get progressText() {
        if (!this.hasLimit) return "";
        return `${this.usedCount}/${this.maxUses}`;
    }

    get perOrgLimit() {
        return this.row?.perOrgLimit ?? null;
    }

    get perOrgLimitText() {
        return this.perOrgLimit == null ? this.$_("w_Unlimited") : this.perOrgLimit;
    }
}
